import { Root, Viewport } from '@radix-ui/react-navigation-menu'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

export interface NavigationMenuProps extends ComponentPropsWithoutRef<
  typeof Root
> {
  viewportClassName?: string
}

export const NavigationMenu = forwardRef<
  ElementRef<typeof Root>,
  NavigationMenuProps
>(
  (
    { className, children, viewportClassName, delayDuration = 0, ...props },
    ref
  ) => (
    <Root
      ref={ref}
      className={cn(
        'relative flex max-w-max flex-1 items-center justify-center',
        className
      )}
      delayDuration={delayDuration}
      {...props}
    >
      {children}
      <NavigationMenuViewport className={viewportClassName} />
    </Root>
  )
)
NavigationMenu.displayName = Root.displayName

const NavigationMenuViewport = forwardRef<
  ElementRef<typeof Viewport>,
  ComponentPropsWithoutRef<typeof Viewport>
>(({ className, ...props }, ref) => (
  <div className={cn('absolute top-full right-0 flex justify-center')}>
    <Viewport
      className={cn(
        'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 relative mt-1.5 h-(--radix-navigation-menu-viewport-height) w-full overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-lg data-[state=closed]:animate-out data-[state=open]:animate-in md:w-(--radix-navigation-menu-viewport-width)',
        className
      )}
      ref={ref}
      {...props}
    />
  </div>
))
NavigationMenuViewport.displayName = Viewport.displayName
